import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.footer`
  background-color: #051b31;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  padding: 10px 17px;

  & > p.call-us {
    padding: 0;
    margin: 0;
    font-size: 13px;
    font-weight: 400;
    text-align: center;
  }

  & > p.copyright {
    width: 100%;
    text-align: center;
    font-size: 9px;
    margin-top: 28px;
  }

  & a {
    color: white;
    text-decoration: none;
  }

  @media screen and (min-width: ${DESKTOP}px) {
    padding: 0 140px;
    padding-bottom: 10px;

    & > p.copyright {
      font-size: 13px;
      padding-left: 100px;
      text-align: left;
      margin-top: 29px;
    }
  }
`;
